import { useCallback, useEffect, useMemo, useState } from "react";
import { AxiosRequest } from "_services/api";
import { HttpError } from "_services/api/HttpError";
import { HttpResponse } from "_services/api/HttpResponse";
import {
  IData,
  IHttpError,
  IHttpResponse,
} from "_services/api/interface/HttpResponse";

export interface IOptionsProcessoFinanceiroDescricao {
  value: any;
  label: any;
  valorServico: string | null;
}

export function useProcessoFinanceiroDescricao() {
  const [
    processosFinanceirosDescricoesOptions,
    setProcessosFinanceirosDescricoesOptions,
  ] = useState<IOptionsProcessoFinanceiroDescricao[]>([]);
  const [
    todosProcessosFinanceirosDescricoesOptions,
    setTodosProcessosFinanceirosDescricoesOptions,
  ] = useState<IOptionsProcessoFinanceiroDescricao[]>([]);
  const [error, setError] = useState<IHttpResponse<IData | any>>();

  const api = useMemo(
    () => AxiosRequest.makeApi(process.env.REACT_APP_MS_AW),
    []
  );

  const listarOptions = useCallback(
    async (idFornecedor?: number) => {
      const params = idFornecedor ? `idFornecedor=${idFornecedor}` : "";
      try {
        const { status, data } = await api.get(
          `/financeiro/descricao/?${params}`
        );
        const response = new HttpResponse(false, status, data);
        setError(response);
        criarOptions(data);

        if (!idFornecedor) {
          criarOptionsTodos(data);
        }
        return response;
      } catch (error: IHttpError<IData, any> | any) {
        criarOptions([]);
        const response = new HttpError<IData>(true, error);
        setError(response);
        return response;
      }
    },
    [api]
  );

  useEffect(() => {
    listarOptions();
  }, [listarOptions]);

  function criarOptions(dados: any[]) {
    const options = dados.map((item) => ({
      value: item.idServico,
      label: item.nomeServico,
      valorServico: item?.valor ?? null,
    }));

    setProcessosFinanceirosDescricoesOptions(options);
  }

  function criarOptionsTodos(dados: any[]) {
    const options = dados.map((item) => ({
      value: item.idServico,
      label: item.nomeServico,
      valorServico: item?.valor ?? null,
    }));

    setTodosProcessosFinanceirosDescricoesOptions(options);
  }

  return {
    processosFinanceirosDescricoesOptions,
    todosProcessosFinanceirosDescricoesOptions,
    listarOptions,
  };
}
